export function getEnv() {
  let backEndApi;
  if (
    window.location.hostname.includes("recallrtrtest.com") ||
    window.location.hostname === "recallrtr-test.azurewebsites.net"
  ) {
    backEndApi = "https://rtrrecallapi-test.azurewebsites.net";
  } else if (
    window.location.hostname.includes("recallrtr.com") ||
    window.location.hostname === "recallrtr.azurewebsites.net"
  ) {
    backEndApi = "https://rtrrecallapi.azurewebsites.net";
  } else {
    backEndApi = "https://rtrrecallapi-test.azurewebsites.net";
    //backEndApi = "https://localhost:44391";
  }
  return backEndApi;
}
